<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back" />
			<img src="@/images/center_text5.png" class="per_right_1name" />
		</div>
		<div class="per_right_2">
			<div class="right-filter">
				<el-form :inline="true">
					<el-form-item label="关联课程：">
						<el-select v-model="courseId" placeholder="请选择关联课程" clearable @change='coursesearchChange'>
							<el-option v-for="item in courselist" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="关联章节：" v-if="courseId!=''">
						<el-cascader v-model="sectionId" placeholder="请选择关联章节" :key='searchKey' :options="courseTree" :props='props' :show-all-levels="false" clearable></el-cascader>
					</el-form-item>
					<el-form-item>
						<div class="feedback_button" @click="onSubmit">
							<img src="@/images/zy_button.png" class="feedback_back" />
							<span>查询</span>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div class="note_right_bottom">
				<div class="noinfo" v-if='noteList.length==0'><i class="el-icon-warning-outline"></i> 还没有发表笔记哦</div>
				<div class="commont-item" :key="item.id" v-for="(item,index) in noteList">
					<div class="commont-itemp0">
						<img :src="baseurl + userinfo.iconurl" v-if="userinfo.iconurl" />
						<img src="@/images/stu.png" v-else/>
					</div>
					<div class="commont-itemp1">
						<div class="commont-name">{{userinfo.name}}</div>
						<div class="time">
							<div class="r">
								<span @click="deleteNote(item,index)" style="cursor: pointer;margin-right: 10px; color: #F01400;"><i class="el-icon-delete-solid"></i>删除</span>
								<span @click="editNote(item,index)" style="cursor: pointer;"><i class="el-icon-edit"></i>编辑</span>
							</div>
						</div>
					</div>
					<div class="commont-itemp2 ">
						<div v-html='item.content'></div>
					</div>
					<div class="commont-itemp2 clearfix">
						<div class="commont-time l">
							{{item.courseName}}-{{item.sectionName}}
						</div>
						<div class="commont-time r">
							{{item.updateTime | formatTime}}
						</div>
					</div>
				</div>
				<div class="table-page" v-if='noteList.length!=0'>
					<el-pagination @current-change='notePageChange' background layout="prev, pager, next" :page='notePage' :total="notetotalrow">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="我的笔记" :visible.sync="note" :append-to-body='true' width="200">
			<div class="articleContent">
				<div id="toolbar">
					<button class="ql-bold"></button>
					<button class="ql-italic"></button>
					<button class="ql-image"></button>
					<select class="ql-align">
						<option value="justify" selected></option>
						<option value="center"></option>
						<option value="right"></option>
					</select>
				</div>
				<quill-editor class="editor" ref="myQuillEditor" :content="content" @change="onEditorChange($event)" :options="editorOption">
				</quill-editor>
				<div class="uploadBox" v-show="false">
					<div class="uploadList">
						<div class="uploadbtn">
							<el-upload :headers='headers' :action="action" :with-credentials='true' :on-success='uploadsuccess' :file-list="fileList" :multiple='false' name='file' accept='image/*' :show-file-list='false'>
								<div class="uploadbtninner">
									<i class="el-icon-plus"></i>
								</div>
							</el-upload>
						</div>
						<div style="clear: both;"></div>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="note = false">取 消</el-button>
				<el-button type="primary" @click="noteChapters">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { getStorageToken } from '@/utils/auth'
	import { getInfo } from '@/api/user.js'
	import { mynoteList, noteRemove, noteUpdate } from '@/api/note.js'
	import { appCourseList, getCourseTree,selectCourseDetail } from '@/api/course.js'
	export default {
		props: {
			majorid: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				note: false,
				firstnote: true,
				editindex: -1,
				editid: '',
				content: '',
				description: '',
				notePage: 1,
				notetotalrow: 0,
				notegetAll: false,
				cangetnote: true,
				sectionId: [],
				searchKey: 0,
				courseId: '',
				courselist: [],
				courseTree: [],
				noteList: [],
				fileList: [],
				filesreview: [],
				headers: {
					'token': '',
				},
				action: '',
				props: {
					value: 'courseDetailId',
					id: 'courseDetailId',
					children: 'childrenList',
					label: 'courseDetailName',
					checkStrictly: true,
				},
				editorOption: {
					modules: {
						toolbar: '#toolbar',
					},
					placeholder: '请输入正文',
				},
			};
		},
		created() {
			var token = getStorageToken();
			if(token) {
				this.getMyInfo();
			}
			this.getCourse();
		},
		methods: {
			getMyInfo() {
				getInfo().then(res => {
					if(res.code == "OK") {
						this.userinfo = res.data;
						this.getNoteList()
					}
				})
			},
			getCourse() {
				var data = {
					page: 1,
					pageSize: 100,
					major_id: this.majorid,
				}
				appCourseList(data).then(res => {
					if(res.code == 0) {
						this.courselist = res.data.listData;
					}
				})
			},
			onSubmit(page) {
				this.notePage = 1;
				this.getNoteList()
			},
			notePageChange(page) {
				this.notePage = page;
				this.getNoteList()
			},
			getNoteList() {
				if(!this.notegetAll && this.cangetnote) {
					this.cangetcommont = false
					var page = this.notePage
					var data = {
						pageSize: this.pageSize,
						page: page,
						courseId: this.courseId ? this.courseId : null,
					}
					if(this.sectionId.length >0) {
						data.sectionId = this.sectionId[this.sectionId.length-1];
					}
					mynoteList(data).then(res => {
						if(res.code == 0) {
							const {
								data
							} = res;
							this.noteList = res.data.listData;
							this.cangetnote = true;
							this.notetotalrow = res.data.totalRow;
						}
					})
				}
			},
			deleteNote(item, index) {
				this.$confirm('确定删除笔记吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var data = {
						noteId: item.id
					}
					noteRemove(data).then(res => {
						if(res.code == 0) {
							this.getNoteList()
						} else {
							this.$message.error('删除失败')
						}
					})
				}).catch(() => {
					this.$message.info('已取消删除')
				});
			},
			noteChapters() {
				var content = this.content;
				var editindex = this.editindex;
				if(content != '') {
					var data = {
						content: content,
						id: this.editid
					}
					noteUpdate(data).then(res => {
						if(res.code == 0) {
							var data = res.data;
							data.realname = this.userinfo.name;
							this.noteList[editindex] = res.data;
							this.note = false;
							this.content = '';
							this.description = '';
							this.$message.success('修改成功');
							this.getNoteList();
						} else {
							this.$message.error('修改笔记失败，请稍后重试')
						}
					})
				} else {
					this.$message.error('请输入内容')
				}
			},
			editNote(item, index) {
				this.editindex = index;
				this.editid = item.id;
				this.content = item.content;
				this.description = '';
				this.opennote()
			},
			opennote() {
				this.note = true;
				if(this.firstnote) {
					this.firstnote = false
					this.editorUpload();
				}
			},
			onEditorChange({
				quill,
				html,
				text
			}) {
				this.description = text;
				this.content = html;
			},
			editorUpload() {
				var that = this;
				var index = 0
				var timer = setInterval(_ => {
					index++;
					var myQuillEditor = that.$refs.myQuillEditor;
					if(myQuillEditor) {
						clearInterval(timer);
						var imgHandler = async function(image) {
							that.addImgRange = that.$refs.myQuillEditor.quill.getSelection();
							if(image) {
								document.getElementsByClassName('uploadbtninner')[0].click()
							}
						}
						this.$refs.myQuillEditor.quill.getModule("toolbar").addHandler("image", imgHandler);
					} else {
						if(index >= 9) {
							clearInterval(timer);
						}
					}
				}, 300)
			},
			uploadsuccess(res, file, fileList) {
				var _this = this;
				if(res) {
					var value = res.location;
					_this.addImgRange = _this.$refs.myQuillEditor.quill.getSelection()
					_this.$refs.myQuillEditor.quill.insertEmbed(_this.addImgRange != null ? _this.addImgRange.index : 0, 'image', value, null)
				}
				if(res.code == 0) {
					var filesreview = this.filesreview;
					filesreview.push(res.data);
					this.filesreview = filesreview;
					this.fileList = [];
				}
			},
			coursesearchChange(val) {
				this.searchKey++;
				if(val) {
					this.courseId = val;
					this.sectionId = [];
					selectCourseDetail({
						courseId: val
					}).then(async res => {
						this.courseTree = res.data;
					})
				} else {
					this.courseId = '';
					this.sectionId = [];
					this.courseTree = [];
					this.getNoteList()
				}
			},
		},
	};
</script>

<style>

</style>